<template>
    <div class="container">
        <h1>Download Oliver’s Instructional Frameworks for Blended and Online Instruction</h1>

        <div class="flex-wrapper">
            <div class="left">
                <a href="https://xperienceeducation-assets.s3.amazonaws.com/framework/documents/Olivers-Blended-Framework-for-Instruction.docx" download><button>Blended Framework</button></a>
            </div>
            <div class="center">
                <a href="https://xperienceeducation-assets.s3.amazonaws.com/framework/documents/Olivers-Online-Framework-for-Instruction.docx" download><button>Online Framework</button></a>
            </div>
            <div class="right">
                 <a href="https://xperienceeducation-assets.s3.amazonaws.com/framework/documents/Correlation-Olivers-Framework-with-Other-National-Standards.xlsx" download><button>National Standard Correlation</button></a>
            </div>
        </div>
    </div>
</template>

<script>




export default {
    "name": "framework-section-1",

    setup() {
    
     
        return{
            
        }

    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/shared.scss';

.container{
    margin-top: 7%;
    margin-bottom: 75px;
    h1{
        color: #662d91;
        font-size: 1rem;

        @media(min-width: $bp-tablet-portrait){
            font-size: 1.5rem;
        }

    }
}

.flex-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    @media(min-width: $bp-tablet-portrait){
        flex-wrap: nowrap;
        margin-left: 5%; 
        margin-right: 5%; 
    }

    .left{
        flex: 100%;
        margin-bottom: 5%;
    }

    .center{
        flex: 100%;
        margin-bottom: 5%;
    }

    .right{
        flex: 100%;
        margin-bottom: 5%;
    }


}

 button{
     cursor: pointer;
        color: white;
        min-width: 100px;
        min-height: 50px;
        background: #662d91;
        padding: 1%;
        border-radius: 5px;
        font-size: 1rem;
        -webkit-box-shadow: 0 8px 6px -6px black;
        -moz-box-shadow: 0 8px 6px -6px black;
        box-shadow: 0 8px 6px -6px black;
}

button:hover{
    background-color: grey;
}


</style>